
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Phone, Mail, MapPin, Clock } from "lucide-react";

const Contact = () => {
  return (
    <div className="min-h-screen bg-[#222222] text-white py-16">
      <div className="container mx-auto px-4">
        <h1 className="text-4xl font-bold mb-8 text-center">Contact Us</h1>
        
        <div className="max-w-4xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
            <Card className="bg-[#333333] border-none">
              <CardContent className="p-6">
                <h2 className="text-2xl font-semibold mb-6">Get in Touch</h2>
                <div className="space-y-4">
                  <div className="flex items-center gap-3">
                    <Phone className="text-blue-400" />
                    <div>
                      <p className="font-medium">Phone</p>
                      <a href="tel:1-800-793-9081" className="text-gray-300 hover:text-blue-400">
                        1-800-793-9081
                      </a>
                    </div>
                  </div>
                  
                  <div className="flex items-center gap-3">
                    <MapPin className="text-blue-400" />
                    <div>
                      <p className="font-medium">Service Area</p>
                      <p className="text-gray-300">Greater Toronto Area</p>
                    </div>
                  </div>
                  
                  <div className="flex items-center gap-3">
                    <Clock className="text-blue-400" />
                    <div>
                      <p className="font-medium">Hours</p>
                      <p className="text-gray-300">Monday - Sunday: 8am - 8pm</p>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card className="bg-[#333333] border-none">
              <CardContent className="p-6">
                <h2 className="text-2xl font-semibold mb-6">Schedule Service</h2>
                <p className="mb-6 text-gray-300">
                  Need your appliance repaired? Contact us now for quick, professional service. We'll diagnose the issue and provide a clear solution.
                </p>
                <Button
                  size="lg"
                  className="w-full bg-blue-600 hover:bg-blue-700"
                  onClick={() => window.location.href = "tel:1-800-793-9081"}
                >
                  <Phone className="mr-2" />
                  Call Now: 1-800-793-9081
                </Button>
              </CardContent>
            </Card>
          </div>

          <div className="mb-12" id="service-area">
            <h2 className="text-2xl font-semibold mb-6">Our Service Area</h2>
            <Card className="bg-[#333333] border-none">
              <iframe 
                src="https://www.google.com/maps/d/u/0/embed?mid=1tXx8f1DWCPD7-k7m2gERAW0ubsf699c&ehbc=2E312F&noprof=1" 
                width="100%" 
                height="480"
                style={{
                  border: 'none',
                  display: 'block',
                  marginBottom: '-50px',
                  marginTop: '-50px'
                }}
                title="Service Area Map"
              ></iframe>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
